export default __webpack_public_path__ + "static/media/theme-mosaic.02417666.png";